import { TypeResponsibleCreate } from './TypeResponsibleCreate'
import { TypeResponsibleEdit } from './TypeResponsibleEdit'
import { TypeResponsibleList } from './TypeResponsibleList'
import { TypeResponsibleShow } from './TypeResponsibleShow'

export { TypeResponsibleCreate, TypeResponsibleEdit, TypeResponsibleList, TypeResponsibleShow }
